import { useLabelVersion } from '../../../../../../features/labels/LabelsProvider';
import { labelCentro } from '../../../../../../features/labels/labels';
import React, { useState } from "react";
import { Grid, Skeleton, Typography } from "@mui/material";
import SignalWifiOffIcon from "@mui/icons-material/SignalWifiOff";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import DrawerNanooxBolt from "./DrawerNanooxBolt";
import LanguageSelector from "../../../../../../components/LanguageSelector";
import CustomTooltip from "../../ui/CustomTooltip";
import ModalCalendario from "./ModalCalendario";

import Itg from "../../../../assets/img/ITG_BLANCO.png";
import Logo from "../../../../assets/img/APP-nanoox-Bolt-Sin-Fondo.png";

function capitalize(value) {
  if (!value) return "";

  const words = value.toLowerCase().split(" ");
  const capitalizedWords = words.map((word) => {
    const normalizedWord = word
      .replace(/los/gi, "Los ")
      .replace(/puerto/gi, "Puerto ");

    return normalizedWord
      .split(" ")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  });

  return capitalizedWords.join(" ").trim();
}

const AppBarNanooxBolt = ({
  version,
  hora,
  translate,
  pendienteData,
  barcos,
  cambioVista,
  idioma,
  selectedCentro,
  setSelectedCentro,
  servidor,
}) => {
  useLabelVersion();
  const t = typeof translate === "function" ? translate : (key) => key;
  const barco = localStorage.getItem("CENTRO");
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);

  const currentTime = hora;
  const time = currentTime?.split(" ")?.[1] || "";
  const rawDate = currentTime
    ? new Date(currentTime).toLocaleDateString(idioma || "es", {
        weekday: "long",
        day: "numeric",
        month: "long",
      })
    : "";
  const capitalizedDate = rawDate
    .split(" ")
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
    .join(" ");

  const isDisconnected = (() => {
    if (!hora) return true;
    const updateTime = new Date(hora);
    const now = new Date();
    const diffMs = now - updateTime;
    const diffMins = diffMs / 1000 / 60;
    return diffMins >= 40;
  })();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <header className="appbar">
      <Grid
        container
        justifyContent="space-between"
        alignContent="center"
        alignItems="center"
        flexDirection="row"
        sx={{
          background: "rgba(255,255,255,0)",
          borderBottom: "solid 0.01vw #e84e0e",
          maxHeight: "8vh",
          padding: "0 2vw",
        }}
      >
        <Grid container justifyContent="space-between" item xs={1}>
          <img
            src={Itg}
            alt={t("itg_logo_alt")}
            style={{ width: "3.5vw", objectFit: "contain" }}
            onClick={toggleDrawer(true)}
            onMouseLeave={toggleDrawer(false)}
            onMouseEnter={toggleDrawer(true)}
          />

          <CustomTooltip
            variant="pipeline"
            title={translate("reportes")}
            color="#c3c3c3"
            arrow
          >
            <button
              type="button"
              className="icon-btn"
              onClick={() => setOpenModal((prev) => !prev)}
              aria-label={t("open_calendar")}
            >
              <CalendarMonthIcon className="icon" />
            </button>
          </CustomTooltip>
        </Grid>

        <Grid container justifyContent="center" item xs={5}>
          {barco && (
            <Grid container style={{ alignItems: "center", justifyContent: "center" }}>
              <Grid container justifyContent="center">
                <Typography style={{ fontSize: "0.75vw", fontWeight: 100 }}>
                  {translate("barco")}:
                </Typography>
              </Grid>
              <Grid container justifyContent="center">
                <Typography style={{ fontSize: "1vw", fontWeight: 700 }}>
                  {pendienteData ? (
                    <Skeleton width="5vw" height="2.5vh" />
                  ) : (
                    labelCentro({ region: "flux", area: "barcos", centro: barco }, capitalize(barco))
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>

        <Grid
          container
          justifyContent="space-around"
          alignContent="center"
          alignItems="center"
          item
          xs={6}
        >
          <LanguageSelector
            translate={translate}
            // sx={{ minWidth: { xs: "3.3rem", sm: "10.5rem" } }}
          />

          <div className="clock-box-nanoox">
            <div className="clock-container-nanoox">
              <div className="last-measurement-nanoox">
                {translate("ultima_medicion")}
                <div />
              </div>
              <div className="main-clock-nanoox">
                <div className="days-row-nanoox">
                  <div>{capitalizedDate}</div>
                </div>
                <div className="time-display-nanoox">{time}</div>
              </div>
              {isDisconnected && (
                <CustomTooltip
                  variant="pipeline"
                  title={translate("disconnected_measurement_40")}
                  color="#c3c3c3"
                  arrow
                >
                  <SignalWifiOffIcon
                    aria-label={translate("disconnected")}
                    style={{
                      color: "#ff6b6b",
                      fontSize: "1vw",
                      position: "absolute",
                      top: "0.5vh",
                      right: "0.7vw",
                    }}
                  />
                </CustomTooltip>
              )}
            </div>
          </div>

          <img
            src={Logo}
            alt={t("nanoox_bolt_logo_alt")}
            style={{ height: "12vh", objectFit: "contain", marginTop: "1vh" }}
            onClick={cambioVista}
          />
        </Grid>
      </Grid>

      <DrawerNanooxBolt
        open={open}
        toggleDrawer={toggleDrawer}
        barcos={barcos}
        version={version}
        translate={translate}
        selectedCentro={selectedCentro}
        setSelectedCentro={setSelectedCentro}
        servidor={servidor}
      />

      <ModalCalendario
        openModal={openModal}
        setOpenModal={setOpenModal}
        idioma={idioma}
        translate={translate}
        servidor={servidor}
      />
    </header>
  );
};

export default AppBarNanooxBolt;
